import React from 'react';
import { cn } from '@/lib/utils';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

export const StatsCard = ({ 
  title, 
  value, 
  change, 
  changeType = 'neutral',
  icon,
  subtitle,
  className
}) => {
  const isPositive = changeType === 'positive' || (typeof change === 'number' && change > 0);
  const isNegative = changeType === 'negative' || (typeof change === 'number' && change < 0);

  return (
    <Card className={cn("", className)}>
      <CardContent className="p-4 sm:p-5">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0 flex-1">
            <p className="text-sm text-muted-foreground truncate">{title}</p>
            <div className="flex items-baseline gap-2 mt-1 flex-wrap">
              <h3 className="text-xl sm:text-2xl font-semibold tracking-tight truncate">{value}</h3>
              {change !== undefined && (
                <Badge 
                  variant={isPositive ? 'gain' : isNegative ? 'loss' : 'secondary'}
                  className="text-xs shrink-0"
                >
                  {isPositive && <i className="fa-solid fa-arrow-up mr-1 text-[10px]"></i>}
                  {isNegative && <i className="fa-solid fa-arrow-down mr-1 text-[10px]"></i>}
                  {typeof change === 'number' ? `${Math.abs(change).toFixed(2)}%` : change}
                </Badge>
              )}
            </div>
            {subtitle && <p className="text-xs text-muted-foreground mt-1 truncate">{subtitle}</p>}
          </div>
          {icon && (
            <div className={cn(
              "w-10 h-10 rounded-lg flex items-center justify-center shrink-0",
              isPositive ? "bg-success/10 text-success" : 
              isNegative ? "bg-destructive/10 text-destructive" : 
              "bg-primary/10 text-primary"
            )}>
              <i className={cn(icon, "text-lg")}></i>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default StatsCard;
